import(/* webpackMode: "eager" */ "/builds/devteam/iconosquare/icofrontend/src/app/(dashboard)/layout.tsx");
